import React from "react";

const SubTitleText = ({ text = "Subtitle Text" }) => {
  return (
    <h2 className="font-normal text-[3.5vw] lg:text-[0.75vw] text-textSecondaryColor text-center">
      {text}
    </h2>
  );
};

export default SubTitleText;
